var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"header-div"}},[_c('img',{attrs:{"src":require('@/assets/images/logo/debtia.svg'),"width":"125"}}),_c('b-navbar-nav',{staticClass:"nav align-items-center ml-auto locale"},[_c('locale')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }